import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-form-estadisticas',
  templateUrl: './form-estadisticas.component.html',
  styleUrls: ['./form-estadisticas.component.css']
})

export class FormEstadisticasComponent implements OnInit {
  idencuesta: string;
  idEncuesta: string;
  nombreEncuesta: string = '';
  idFormulario: string;
  idRegistro: string;
  registro: any;
  reportePBI: string;
  cargando: boolean = false;

  constructor(
    public data: DataService,
    private route: ActivatedRoute
  ) {
    this.data.encuestaSeleccionada$.subscribe(valor => {
      this.idencuesta = valor ?? '';
      this.obtenerReporte();
    });
  }

  ngOnInit() {
    this.idFormulario = this.route.snapshot.paramMap.get('id');
  }

   obtenerReporte() {

    // Obtener la ruta de configuración de reportes
    const rutaReportes = environment.ruta_configuracion_reportes;
    
    // Extraer los parámetros de la ruta
    const partes = rutaReportes.split('/').filter(parte => parte !== '');
    
    if (partes.length >= 3) {
      this.idFormulario = partes[0];
      this.idEncuesta = partes[1];
      this.idRegistro = partes[2];
      
      console.log('ID Formulario:', this.idFormulario);
      console.log('ID Encuesta:', this.idEncuesta);
      console.log('ID Registro:', this.idRegistro);

      // Obtener el registro
      this.cargando = true;
      this.data.ObtenerRegistro(this.idRegistro).subscribe({
        next: (resultado) => {
          
          this.registro = resultado;
          this.cargando = false;
          //busca en this.registro.Respuestas.EncuestaReporte el campo ReportePBI con el id de this.idencuesta
          const config = this.registro.Respuestas.EncuestaReporte.find(e => e.Encuesta === this.idencuesta);
          
          if(config){
            this.reportePBI = config.ReportePBI;
          }
          else{
            this.reportePBI = '';
          }

        },
        error: (error) => {
          console.error('Error al obtener el registro:', error);
          this.cargando = false;
        }
      });
    } else {
      console.error('La ruta de configuración de reportes no tiene el formato esperado');
    }
  }
}
